export class ToggleHover {
    constructor(hoverElem, hoverClass = 'active') {
        this.hoverElem = hoverElem;
        this.hoverClass = hoverClass;

        this.events();
    }

    hover() {
        this.hoverElem.classList.toggle(this.hoverClass);
    }

    events() {
        this.hoverElem.addEventListener("touchstart", this.hover.bind(this));
        this.hoverElem.addEventListener("touchend", this.hover.bind(this));
        this.hoverElem.addEventListener("mouseenter", this.hover.bind(this));
        this.hoverElem.addEventListener("mouseleave", this.hover.bind(this));
    }
}